export default {
    list: {
        en: "Inglés",
        it: "Italiano",
        ru: "Ruso",
        es: "Español",
    },
}
